import React, { Component } from 'react';
import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';

const GiftWrapper = styled.div`
    position: relative;
    width: 32%;
    height: 514px;
    border: 1px solid ${COLORS.lightGrey};
    background: url(${props => props.srcImg}) no-repeat center center;
    background-size: cover;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    font-family: 'robotoRegular', Arial, Helvetica, sans-serif;
    transition: box-shadow 0.2s linear;
    overflow: hidden;
    justify-content: flex-end;
    margin: 0 1% 20px 0;
    &:hover {
        box-shadow: 0 0 20px rgba(0,0,0,0.15);
    }
    @media (max-width: 1280px) {
        width: 48%;
    }
    @media (max-width: 883px) {
        height: 542px;
    }
    @media (max-width: 760px) {
        width: 100%;
        max-width: 400px;
        margin: 0 0 20px 0;
    }
`;
const Text = styled.div`
    color: ${COLORS.white};
    font-size: 20px;
    line-height: 28px;
    margin: 0 30px;
`;
const Button = styled(StyledButton)`
    margin: 30px;
    width: 100%;
    @media (max-width: 907px) {
        padding: 10px;
    }
`;

class BannerPromo extends Component {

    componentDidMount() {
        dataLayerPush({
            event: 'UAevent',
            category: 'banner on the promo page',
            action: 'view banner',
            label: this.props.bannerInfo.id
        });
    }

    handleClick = () => {
        const { bannerInfo } = this.props;

        dataLayerPush({
            event: 'UAevent',
            category: 'banner on the promo page',
            action: 'click banner',
            label: bannerInfo.id
        });
        location.href = bannerInfo.link;
    }

    render() {
        const { bannerInfo = {} } = this.props;
        return (
            <GiftWrapper srcImg={bannerInfo.image}>
                <Text>{bannerInfo.text}</Text>
                <div>
                    <Button
                        type='primary'
                        text={bannerInfo.buttonText}
                        onClick={this.handleClick}
                        href={bannerInfo.link}
                    />
                </div>
            </GiftWrapper>
        );
    }
}

export default BannerPromo;
